import $ from 'jquery'

function setDisplayNone() {
    $('#div_about').css('display', 'none');
    $('#div_toc').css('display', 'none');
    $('#div_intro').css('display', 'none');
}

$('#btn_about').click(function () {
    setDisplayNone();
    $('#div_about').css('display', 'block');
});
$('#btn_toc').click(function () {
    setDisplayNone();
    $('#div_toc').css('display', 'block');
});
$('#btn_intro').click(function () {
    setDisplayNone();
    $('#div_intro').css('display', 'block');
});

